import { setupWorker } from 'msw'
import { handlers } from './handlers/index'

// Set up the Service Worker with the handlers
export const worker = setupWorker(...handlers)
